import { Box } from "@chakra-ui/react";

/**
 * @typedef {object} Props
 * @prop {string} icon
 * @prop {string} [size]
 * @prop {import("@chakra-ui/react").BoxProps["color"]} [color]
 */
/**
 * @param {Props} props
 */
export function Icon({ icon: iconName, size = "20px", color }) {
  const prefix = `${iconName.split("_")[0]}_`;

  return (
    <Box
      as="span"
      className="material-symbols-outlined"
      display="block"
      fontSize={`${size} !important`}
      w={size}
      h={size}
      overflow="hidden"
      color={color ?? "inherit"}
      userSelect="none"
      aria-hidden="true"
      tabIndex={-1}
    >
      {iconName.replace(prefix, "")}
    </Box>
  );
}
